import React from "react";
import AddIcon from "@mui/icons-material/Add";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import {
Box,
Typography,
Accordion,
AccordionSummary,
AccordionDetails,
List,
ListItem,
ListItemIcon,
ListItemText,
Button,
Link,
Stack,
} from "@mui/material";
import GetEBookButton from "./GetEBookButton";

const chapters = [
{
    title: "CHAPTER 1: ALL ABOUT ME (Self-Discovery)",
    tools: [
        "Tool 1: Personal Values – Helps children explore what truly matters to them and what guides their choices.",
        "Tool 2: All About Me Board – A creative collage where kids express their identity, interests, and dreams.",
        "Tool 3: Affirmation Poster – Encourages self-belief through positive statements that boost confidence.",
        "Tool 4: Superpower Stone – A symbolic object reminding children of their unique strengths and inner power.",
    ],
},
{
    title: "CHAPTER 2: MY EMOTIONS",
    tools: [
        "Tool 5: Wheel of Emotions Poster – Teaches kids to name and understand a wide range of emotions.",
        "Tool 6: Emotion Cards – Helps children identify, label, and communicate their feelings visually.",
        "Tool 7: Emotion Thermometer – Guides children to rate the intensity of their emotions and respond calmly.",
        "Tool 8: Ways I Can Calm Myself When… Poster – Offers healthy coping strategies for difficult moments.",
        "Tool 9: My Journal – A private space for children to reflect on their feelings, experiences, and thoughts.",
    ],
},
{
    title: "CHAPTER 3: MY FAMILY",
    tools: [
        "Tool 10: My Special Family – Helps children appreciate the uniqueness and love within their family.",
        "Tool 11: Our Family Fun List Poster – Inspires families to plan joyful and bonding activities together.",
        "Tool 12: Family Rituals – Encourages creating small, meaningful traditions that strengthen connection.",
        "Tool 13: Family Bucket-list – A shared list of dreams and adventures to experience as a family.",
        "Tool 14: Family Rules – Guides families to agree on shared values and respectful household behaviors.",
        "Tool 15: Weekly Family Meeting – Builds open communication and teamwork through regular check-ins.",
        "Tool 16: Family Treasure Box – A keepsake for storing special memories, notes, or gratitude moments.",
    ],
},
{
    title: "CHAPTER 4: MY CHALLENGES & GROWTH MINDSET",
    tools: [
        "Tool 17: My Challenge Shield – Empowers children to face difficulties with courage and self-belief.",
        "Tool 18: Growth Mindset vs Fixed Mindset – Helps kids understand how their mindset affects learning and resilience.",
        "Tool 19: The Power of Yet – Encourages persistence by reframing “I can’t” into “I can’t yet.",
        "Tool 20: Problem-Solving Wheel – Provides simple steps to think through and solve everyday challenges.",
        "Tool 21: Problem Solution – Encourages reflection on past problems and creative ways to overcome them.",
        "Tool 22: Growth Mindset Planting – A hands-on metaphor showing how effort helps ideas and skills grow.",
    ],
},
{
    title: "CHAPTER 5: POSITIVITY",
    tools: [
        "Tool 23: Affirmation Bracelets – A fun, wearable reminder of personal strengths and positivity.",
        "Tool 24: “I’m Bored...40 Fun Ideas” Poster – Reframes boredom into an opportunity for creativity and joy.",
        "Tool 25: Tablemat: Affirmations – Brings positive language and self-talk into daily family routines.",
        "Tool 26: Memory Game – Reinforces positive words, emotions, and traits through playful repetition.",
        "Tool 27: Lunchbox Notes – Small surprise messages that spread encouragement and love during the day.",
    ],
},
{
    title: "CHAPTER 6: KINDNESS",
    tools: [
        "Tool 28: Kindness Challenge Poster – Inspires daily acts of kindness to build empathy and connection.",
        "Tool 29: How to Be a Good Friend – Teaches qualities of friendship and how to nurture healthy relationships.",
    ],
},
{
    title: "CHAPTER 7: GRATITUDE",
    tools: [
        "Tool 30: Gratitude Jar – Encourages families to record and celebrate moments they’re thankful for.",
        "Tool 31: Thank You Notes – Helps children express appreciation and strengthen relationships.",
    ],
},
{
    title: "CHAPTER 8: MY PURPOSE & LIFE CONTRIBUTION",
    tools: [
        "Tool 32: Dream Big Poster – Inspires children to visualize their biggest dreams without limits.",
        "Tool 33: Morning & Night Routine – Builds structure, balance, and self-care habits in daily life.",
        "Tool 34: Daily Planner – Teaches goal-setting and time management through a child-friendly layout.",
        "Tool 35: Yearly Calendar – Helps children plan long-term goals and celebrate achievements.",
        "Tool 36: Vision board – Encourages creative visualization of dreams and values for the future.",
        "Tool 37: Dreams & Challenges Tree – Shows how effort and persistence help dreams grow despite obstacles.",
        "Tool 38: Action Plan to Success – Breaks big dreams into achievable, realistic steps.",
        "Tool 39: How to Achieve My Dreams Poster – Summarizes the process of turning hope into action with clear goals.",
    ],
},
];
const TableOfContent = () => (
        <Box
            sx={{
                mx: "auto",
                mt: 2, // move it up (less down)
                p: { xs: 2, md: 3 }, // slightly less padding
                bgcolor: "#fff",
                borderRadius: 3,
                // boxShadow removed
            }}
        >

        <Typography
            variant="h3"
            component="h3"
            
            fontWeight={400}
            fontSize={{ xs: 32, md: 48 }}
            color="rgba(28, 30, 46, 1)"
            mb={4}
            textAlign="center"
        >
            <strong>Table Of Contents</strong>
        </Typography>
        <Stack spacing={2}>
            {chapters.map((chapter, idx) => (
                <Accordion key={chapter.title} sx={{ borderRadius: 2 }}>
                    <AccordionSummary
                        expandIcon={<AddIcon />}
                        aria-controls={`panel${idx}-content`}
                        id={`panel${idx}-header`}
                        sx={{
                            fontWeight: 700,
                            fontSize: 20,
                            color: "rgba(24, 24, 24, 1)",
                            bgcolor: idx % 2 === 0 ? "custom.blue" : "custom.red", // toggling colors
                            borderRadius: 2,
                            textAlign: "center",
                            justifyContent: "center",
                            width: "100%",
                        }}
                    >
                        {chapter.title}
                    </AccordionSummary>
                    <AccordionDetails>
                        <List>
                            {chapter.tools.map((tool, tidx) => (
                                <ListItem key={tool} alignItems="flex-start" sx={{ pl: 0 }}>
                                    <ListItemIcon sx={{ minWidth: 36 }}>
                                        <BuildOutlinedIcon sx={{ color: "#4a4a4a" }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <Typography
                                                
                                                fontSize={18}
                                                color="rgba(1,1,1,1)"
                                                fontWeight={400}
                                            >
                                                {tool}
                                            </Typography>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Stack>
        <Box mt={6} textAlign="center">
            <GetEBookButton />
        </Box>
    </Box>
);
export default TableOfContent;